/** Sentinel UUID for the CONORBIT platform-owner organisation */
export const CONORBIT_ORG_ID = '00000000-0000-0000-0000-000000000000'

/** Sentinel UUID for the ECOWAS Parliament institution organisation */
export const ECOWAS_ORG_ID = '00000000-0000-0000-0000-000000000001'
